import React from "react";
const styles = `
 .placeholder-option {
    color: #6c757d;
  }
`;
const SelectFilter = ({ column, constants, handleInputFilterChangeNoDebounce }) => {
   const handleChange = (e) => {
      const selectedValue = e.target.value;
      handleInputFilterChangeNoDebounce(column.id, selectedValue);
   };
   return (
      <>
         <select className="form-select mt-2" aria-label="{column.id}" value={column.value || ""} onChange={handleChange}>
            <option className="placeholder-option" value="">
               Select Type...
            </option>
            {constants.map((constant) => (
               <option key={constant.value} value={constant.value}>
                  {constant.label}
               </option>
            ))}
         </select>
      </>
   );
};
export default SelectFilter;

// THis component work but for sime reason the inpit element changes width all the time with tanstack v8
// Will not use until I cn firgure out why

// import React, { useState, useEffect } from "react";
// import Select from "react-select";

// const SelectFilter = ({ column, constants, handleInputFilterNoDebounceChange, thRef }) => {
//    const [selectedValue, setSelectedValue] = useState({
//       value: "",
//       label: "",
//    });
//    const [columnWidth, setColumnWidth] = useState(200); // Default fallback width

//    useEffect(() => {
//       // Measure the <th> width dynamically
//       if (thRef && thRef.current) {
//          console.log("COLUMNWIDTH:", thRef.current.offsetWidth);
//          setColumnWidth(thRef.current.offsetWidth);
//       }
//    }, [thRef]);

//    // Set initial selected value based on the column filter value
//    useEffect(() => {
//       if (column.value) {
//          const selectedOption = constants.find((s) => s.value === column.value);
//          if (selectedOption) {
//             setSelectedValue(selectedOption);
//          }
//       }
//    }, [column.value, constants]);

//    const handleSelectChange = (selectedOption) => {
//       setSelectedValue(selectedOption);
//       // Call the parent function to update the filter state
//       handleInputFilterNoDebounceChange(column.id, selectedOption ? selectedOption.value : "");
//    };

//    const customStyles = {
//       control: (provided, state) => ({
//          ...provided,
//          padding: "0px",
//          //display: "flex",
//          //justifyContent: "space-between",
//          fontSize: "0.875rem",
//          fontWeight: "400",
//          lineHeight: "1.5",
//          minHeight: "34px",
//          color: "var(--bs-body-color)",
//          backgroundColor: "#fff",
//          border: "var(--bs-border-width) solid var(--bs-border-color)",
//          borderRadius: "var(--bs-border-radius)",
//          transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
//          height: "auto",
//          borderColor: state.isFocused ? "#ccd2da" : provided.borderColor, // Apply border color on focus
//          boxShadow: state.isFocused ? "0 1px 1px rgba(226, 229, 236, 0.25), 0 2px 2px rgba(226, 229, 236, 0.2), 0 4px 4px rgba(226, 229, 236, 0.15), 0 8px 8px rgba(226, 229, 236, 0.1)" : provided.boxShadow, // Apply box-shadow on focus
//          "&:hover": {
//             borderColor: "#ccd2da", // Optional hover effect
//          },
//       }),
//       valueContainer: (provided) => ({
//          ...provided,
//          flexWrap: "nowrap", // Prevent wrapping of text
//       }),
//       singleValue: (provided) => ({
//          ...provided,
//          margin: "0",
//          whiteSpace: "nowrap", // Prevent wrapping
//          overflow: "hidden",
//          textOverflow: "ellipsis", // Add ellipsis for long text
//       }),
//       input: (provided) => ({
//          ...provided,
//          //  padding: "0.406rem 0.75rem",
//          fontSize: "0.875rem",
//          fontWeight: "400",
//          lineHeight: "1.5",
//          color: "var(--bs-body-color)",
//          flex: "1 1 auto",
//       }),
//       indicatorsContainer: (provided) => ({
//          ...provided,
//          padding: "4px", // Custom padding
//       }),
//       dropdownIndicator: (provided) => ({
//          ...provided,
//          padding: "0 0.375rem", // Adjust dropdown indicator padding
//          color: "var(--bs-body-color)",
//       }),
//       indicatorSeparator: (provided) => ({
//          ...provided,
//          marginBottom: "4px",
//          marginTop: "4px",
//       }),
//    };

//    return (
//       <div style={{ position: "relative", width: "300px" }}>
//          <Select options={constants} value={constants.find((s) => s.value === column.value)} styles={customStyles} />
//       </div>
//    );
// };

// export default SelectFilter;
